<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Blockchain Solutions</h1>
      </div>
    </div>
  </div>
</header>
<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Blockchain para nuevos <span class="highlight-green">modelos digitales</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Soluciones Web3, contratos inteligentes e infraestructura segura para proyectos innovadores.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Desarrollo de DApps y smart contracts</li>
          <li><i class="bi bi-check-circle-fill"></i> Consultoría estratégica</li>
          <li><i class="bi bi-check-circle-fill"></i> Integración y mantenimiento continuo</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-currency-bitcoin"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-globe2"></i>
          </div>
          <h4 class="modern-service-card-title">Web3 & Consultoría</h4>
          <p>Asesoramos la integración de ecosistemas Web3 y modelos descentralizados en tu operación.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-file-earmark-code"></i>
          </div>
          <h4 class="modern-service-card-title">Smart Contracts</h4>
          <p>Desarrollamos contratos inteligentes seguros, automatizados y eficientes.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-coin"></i>
          </div>
          <h4 class="modern-service-card-title">Activos Digitales</h4>
          <p>Creamos infraestructura para tokens, activos digitales y nuevos modelos de valor.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Equipo experto en blockchain</li>
          <li><i class="bi bi-check-circle-fill"></i> Transparencia y acompañamiento total</li>
          <li><i class="bi bi-check-circle-fill"></i> Soporte y capacitación continua</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Explora cómo blockchain puede transformar tu modelo de negocio.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
